import Vue from 'vue';
import Vuex from 'vuex';

import auth from './auth/';
import snackbar from './snackbar/';
import members from './members/';
import tenants from './tenants/';
import drawer from './drawer/';
import errors from './errors/';
import vehicles from './vehicles/';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    snackbar,
    members,
    tenants,
    drawer,
    errors,
    vehicles
  }
});
